import Mastercard from "@/modules/common/icons/mastercard"
import Visa from "@/modules/common/icons/visa"
import { IconProps } from "types/icon"

/** Visa + Mastercard logos — `size` is the shared height in px */
const VisaMastercard = ({ size = "16", ...props }: IconProps) => {
  const logoHeight = String(size)

  return (
    <span
      className="inline-flex items-center gap-2 shrink-0"
      aria-label="Visa, Mastercard"
      {...props}
    >
      <Visa size={logoHeight} />
      <Mastercard size={logoHeight} />
    </span>
  )
}

export default VisaMastercard
